import * as types from './action-types';

export const palettesState = (ascendancy) => ({
  variations: {},
});

export function palettesReducer(state = palettesState(), {payload, type}) {
  switch (type) {
    case types.SET_PALETTE_VARIATION:
      return Object.assign({}, state, {
        variations: {...state.variations, [payload.name]: payload.variation},
      });
    
    default: 
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/core/palettes/reducer.js